/*=========================================================================================
  File Name: moduleStyleState.js
  Description: Style Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  styles: []
}
